"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _ColorPlugin = _interopRequireDefault(require("./ColorPlugin"));

var _icons = _interopRequireDefault(require("icons/icons"));

var _colors = require("HubStyleTokens/colors");

var tooltip = _react.default.createElement(_FormattedHTMLMessage.default, {
  message: "draftPlugins.highlightPlugin.tooltip"
});

var _default = (0, _ColorPlugin.default)({
  colors: [[_colors.MARIGOLD]],
  getStyleName: function getStyleName(hexString) {
    return "BACKGROUND-COLOR-" + hexString;
  },
  cssProperty: 'background-color',
  tooltip: tooltip,
  iconName: _icons.default.BRUSH
});

exports.default = _default;
module.exports = exports.default;